export default "__VITE_ASSET__DM$HDG62__"